import { render, staticRenderFns } from "./SvTable.vue?vue&type=template&id=642f28f1&scoped=true&lang=pug&"
import script from "./SvTable.vue?vue&type=script&lang=js&"
export * from "./SvTable.vue?vue&type=script&lang=js&"
import style0 from "./SvTable.vue?vue&type=style&index=0&id=642f28f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f28f1",
  null
  
)

export default component.exports